<template>
	<el-cascader
		v-model="select"
		:options="options"
		:props="props"
		@change="handleChange"
		clearable
		:disabled="disabled"
		style="width: 100%" />
</template>

<script>
	export default {
		name: 'RegionCascader',
		props: {
			value: {
				type: [String, Array],
				default: () => '',
			},
			options: {
				type: Array,
				default: () => [],
			},
			props: {
				type: Object,
				default: () => {},
			},
			disabled: {
				type: Boolean,
				default: () => false,
			},
		},
		data() {
			return {
				select: [],
			};
		},
		watch: {
			value(val) {
				if (typeof val === 'string') {
					let res = [];
					let data = val.replace(/(0{3}(0{3}(0{2}(0{2}(0{2})?)?)?)?)?$/, '').trim();
					if (data.length >= 2) {
						let provinces = data.substring(0, 2);
						res.push(provinces + '0000');
					}
					if (data.length >= 4) {
						let city = data.substring(2, 4);
						if (city !== '00') {
							res.push(data.substring(0, 4) + '00');
						}
					}
					if (data.length >= 6) {
						res.push(data.substring(0, 6));
					}
					this.select = res;
				} else if (val instanceof Array) {
					this.select = val;
				} else {
					console.error('Invalid region cascader value!');
				}
			},
		},
		methods: {
			handleChange(e) {
				this.$emit('handleChange', e);
			},
		},
	};
</script>

<style scoped lang="scss"></style>
